import React, { Fragment, useState, useEffect } from "react";
import { Portal } from "react-portal";
import { useTranslation } from "react-i18next";

import "../styles/warningModal.css";

import Backdrop from "sulu-admin-bundle/components/Backdrop";
import Button from "sulu-admin-bundle/components/Button";

const WarningModal = ({ isOpen, confirmHandler, cancelHandler, loading }) => {
    const [visible, setVisible] = useState(false);
    const [active, setActive] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (isOpen) {
            setVisible(true);

            requestAnimationFrame(() => setActive(true));
        } else {
            setActive(false);
        }
    }, [isOpen]);

    const handleTransitionEnd = () => {
        if (!active) {
            setVisible(false);
        }
    };

    if (!visible) return null;

    return (
        <Fragment>
            <Portal>
                <Backdrop />
                <div
                    className={`modal__wrapper ${active ? "active" : ""}`}
                    onTransitionEnd={handleTransitionEnd}
                >
                    <h2 className="modal__title">
                        {t("gamedays.matchday_block.from_date_title")}
                    </h2>
                    <p
                        className="modal__content"
                        dangerouslySetInnerHTML={{
                            __html: t("gamedays.matchday_block.from_date_info"),
                        }}
                    />

                    <div class="modal__buttons">
                        <Button skin="secondary" onClick={cancelHandler}>
                            {t("sulu_admin.button_cancel")}
                        </Button>
                        <Button
                            skin="primary"
                            loading={loading}
                            onClick={confirmHandler}
                        >
                            {t("sulu_admin.button_apply")}
                        </Button>
                    </div>
                </div>
            </Portal>
        </Fragment>
    );
};

export default WarningModal;
